import styled from 'styled-components';

export const FeaturedList = styled.ul`
  width: 100%;
  
  margin-bottom: 40px;
  
  &::before {
    content: "";
    
    position: absolute;
    z-index: -1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -49%);
    
    width: 100%;
    height: 115%;
    
    background-color: #f7f7f7;
  }
  
  @media(min-width: 700px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 30px;
    grid-row-gap: 30px;
    margin-bottom: 0;
    
    &::before {
      transform: translate(-50%, -49%);
      
      height: 125%;
    }
  }
  
  @media(min-width: 950px) {
    grid-template-columns: repeat(4, 1fr);
    
    &::before {
      transform: translate(-50%, -44%);
      
      height: 170%;
    }
  }
`;

export const FeaturedItem = styled.li`
  &:not(:last-child) {
    margin-bottom: 35px;
  }
  
  a {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
  
  @media(min-width: 700px) {
    &:not(:last-child) {
      margin-bottom: 0;
    }
  }
`;

export const FeaturedButtonContainer = styled.div`
  width: 100%;
  
  a {
    display: inline-block;
    width: 100%;
    
    span {
      width: 100%;
    }
    
    svg {
      margin-left: 10px;
      fill: ${({ theme }) => theme.blue};
      stroke: ${({ theme }) => theme.blue};
    }
  }
  
  @media(min-width: 700px) {
    display: none;
  }
`;

export const FeaturedHeaderAdditionalContainer = styled.div`
  display: none;
  
  svg {
    fill: ${({ theme }) => theme.blue};
    stroke: ${({ theme }) => theme.blue};
  }
  
  @media(min-width: 700px) {
    display: block;
  }
`;


export const FeaturedAll = styled.span`
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: ${({ theme }) => theme.blue};
  
  a {
    color: inherit;
  }
  
  svg {
    margin-left: 10px;
  }
`;
